<template>
  <nav :aria-label="label" v-if="show">
    <ul class="pagination">
      <li v-if="pagination.current_page > 1"
        :class="{ 'disabled': pagination.current_page <= 1 }">
        <a aria-label="Previous"
          href="#1"
          @click.prevent="goTo(1)">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <li v-for="page in pages" :key="page"
        :class="{ 'active' : pagination.current_page === page }">
        <a :href="`#${page}`" @click.prevent="goTo(page)">
          {{ page }}
        </a>
      </li>

      <li v-if="pagination.current_page < pagination.total_pages">
        <a aria-label="Next"
          :href="`#${pagination.total_pages}`"
          @click.prevent="goTo(pagination.total_pages)">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { range } from 'lodash';

export default {
  data() {
    return {
      pages: [],
      show: false,
    };
  },

  props: {
    label: {
      type: String,
      required: false,
      default: 'Pagination',
    },

    pagination: {
      type: Object,
      required: true,
    },
  },

  watch: {
    pagination() {
      this.createPages();
    },
  },

  methods: {
    goTo(page) {
      this.$emit('goto-page', page);
    },

    createPages() {
      this.show = false;
      const current = this.pagination.current_page;
      const step = 4;
      const min = 1;
      const max = this.pagination.total_pages;

      let start;
      let end;
      let pageRange;

      if (current === 1) {
        pageRange = (max <= 8) ? max : 8;
        start = 1;
        end = current + pageRange;
      } else if (current === max) {
        pageRange = (max <= 8) ? max : 8;
        start = (current - pageRange) + 1;
        end = current + 1;
      } else {
        start = (current - (step - 1) > min) ? current - (step - 1) : min;
        end = (current + step < max) ? current + step : max + 1;
      }

      this.pages = range(start, end);
      this.show = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/common/Pagination.vue